import { CommandConstituentLevelConversion } from "./commands/cmdConstituentLevelConversion.ts";
import { CommandConversionJourney } from "./commands/cmdConversionJourney.ts";
import { CommandConversionsLeadingIndicators } from "./commands/cmdConversionsLeadingIndicators.ts";
import { CommandCumulativeInvoice } from "./commands/cmdCumulativeInvoice.ts";
import { CommandEngagement } from "./commands/cmdEngagement.ts";
import { CommandEngagementTeam } from "./commands/cmdEngagementTeam.ts";
import { CommandFileSummary } from "./commands/cmdFileSummary.ts";
import { CommandFiltersGuideposts } from "./commands/cmdFiltersGuideposts.ts";
import { CommandLastTermDistribution } from "./commands/cmdLastTermDistribution.ts";
import { CommandLaunchDate } from "./commands/cmdLaunchDate.ts";
import { CommandLaunchGoal } from "./commands/cmdLaunchGoal.ts";
import { CommandLaunchKeyDates } from "./commands/cmdLaunchKeyDates.ts";
import { CommandListSize } from "./commands/cmdListSize.ts";
import { CommandMotivationPrinciples } from "./commands/cmdMotivationPrinciples.ts";
import { CommandRecommendedActions } from "./commands/cmdRecommendedActions.ts";
import { CommandRunningIdeas } from "./commands/cmdRunningIdeas.ts";
import { CommandScheduledIdeas } from "./commands/cmdScheduledIdeas.ts";
import { CommandGetTopGuidePosts } from "./commands/cmdTopGuidePosts.ts";
import { CommandGetListSizeOverTime } from "./commands/cmdTopListSizeOverTime.ts";
import { CommandTopPerformingNetwork } from "./commands/cmdTopPerformingNetwork.ts";
import { CommandTotalGpSummary } from "./commands/cmdTotalGpSummary.ts";
export class GuidePostService {

    async getTopGuidePosts(affiliateSelected: String, launchSelected: String, startDate: String, endDate: String, periodSelected: String) {
        const cmd = new CommandGetTopGuidePosts();
        const results = await cmd.run(affiliateSelected,launchSelected, startDate, endDate, periodSelected);
        return results;
    }

    async getFiltersData(affiliateSelected: String, launchSelected: String) {
        const cmd = new CommandFiltersGuideposts();
        const results = await cmd.run(affiliateSelected, launchSelected);
        return results;
    }

    async getConstituentLevelConversion(launchSelected: String ) {
        const cmd = new CommandConstituentLevelConversion();
        const results = await cmd.run(launchSelected);
        return results;
    }

    async getFileSummaryData(launchSelected: String) {
        const cmd = new CommandFileSummary();
        const results = await cmd.run(launchSelected);
        return results;
    }

    async getLaunchDatesData(launchSelected: String, timePeriodSelected: String) {
        const cmd = new CommandLaunchDate();
        const results = await cmd.run(launchSelected, timePeriodSelected);
        return results;
    }

    async getTopListSizeOverTime(launchSelected: String, timePeriodSelected: String) {
        const cmd = new CommandGetListSizeOverTime();
        const results = await cmd.run(launchSelected, timePeriodSelected);
        return results;
    }

    async getLastTermDistribution(launchSelected: String, timePeriodSelected: String) {
        const cmd = new CommandLastTermDistribution();
        const results = await cmd.run(launchSelected, timePeriodSelected);
        return results;
    }

    async getTopPerformingNetwork(affiliateId: String, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String) {
        const cmd = new CommandTopPerformingNetwork();
        const results = await cmd.run(affiliateId, launchSelected, timePeriodSelected, startDate, endDate);
        return results;
    }

    async getListSize(affiliateId: String, launchSelected: String, timePeriodSelected: String) {
        const cmd = new CommandListSize();
        const results = await cmd.run(affiliateId, launchSelected, timePeriodSelected);
        return results;
    }

    async getLaunchGoal(affiliateId: String, launchSelected: String, timePeriodSelected: String) {
        const cmd = new CommandLaunchGoal();
        const results = await cmd.run(affiliateId, launchSelected, timePeriodSelected);
        return results;
    }

    async getRecommendedActions(affiliateId: String, launchSelected: String, timePeriodSelected: String, sort: String) {
        const cmd = new CommandRecommendedActions();
        const results = await cmd.run(affiliateId, launchSelected, timePeriodSelected, sort);
        return results;
    }

    async getConversionJourney(affiliateId: String, startDate:String, endDate: String,launchSelected: String, timePeriodSelected: String) {
        const cmd = new CommandConversionJourney();
        const results = await cmd.run(affiliateId, startDate, endDate, launchSelected, timePeriodSelected);
        return results;
    }

    async getLaunchKeyDates(afiliateSelected: String, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String, sort: String) {
        const cmd = new CommandLaunchKeyDates();
        const results = await cmd.run(afiliateSelected, launchSelected, timePeriodSelected, startDate, endDate, sort);
        return results;
    }

    async getTotalGpSummary(launchSelected: String, startDate: String, endDate: String) {
        const cmd = new CommandTotalGpSummary();
        const results = await cmd.run(launchSelected, startDate, endDate);
        return results;
    }
    async getEngagementTeam(affiliateSelected: String, launchSelected: String, startDate: String, endDate: String, periodSelected: String) {
        const cmd = new CommandEngagementTeam();
        const results = await cmd.run(affiliateSelected,launchSelected, startDate, endDate, periodSelected);
        return results;
    }

    async getLeadingIndicators(affiliateSelected: String, launchSelected: String, startDate: String, endDate: String, periodSelected: String) {
        const cmd = new CommandConversionsLeadingIndicators();
        const results = await cmd.run(affiliateSelected,launchSelected, startDate, endDate, periodSelected);
        return results;
    }

    async getRunningIdeas(affiliateSelected: String, launchSelected: String, startDate: String, endDate: String, periodSelected: String) {
        const cmd = new CommandRunningIdeas();
        const results = await cmd.run(affiliateSelected,launchSelected, startDate, endDate, periodSelected);
        return results;
    }

    async getScheduledIdeas(affiliateSelected: String, launchSelected: String, startDate: String, endDate: String, periodSelected: String) {
        const cmd = new CommandScheduledIdeas();
        const results = await cmd.run(affiliateSelected,launchSelected, startDate, endDate, periodSelected);
        return results;
    }

    async getMotivationPrinciples(affiliateSelected: String, launchSelected: String, startDate: String, endDate: String, periodSelected: String) {
        const cmd = new CommandMotivationPrinciples();
        const results = await cmd.run(affiliateSelected,launchSelected, startDate, endDate, periodSelected);
        return results;
    }

    async getEngagementData(affiliateSelected: String, launchSelected: String, startDate: String, endDate: String, periodSelected: String) {
        const cmd = new CommandEngagement();
        const results = await cmd.run(affiliateSelected,launchSelected, startDate, endDate, periodSelected);
        return results;
    }

    async getCumulativeInvoice(launchSelected: String, timePeriodSelected: String) {
        const cmd = new CommandCumulativeInvoice();
        const results = await cmd.run(launchSelected, timePeriodSelected);
        return results;
    }
}
